import React, { FunctionComponent } from "react";

const ConversationQuestionWarningIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/messages-chat-smileys/conversation/conversation-question-warning
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 5.625C6.75 5.25416 6.85997 4.89165 7.06599 4.58331C7.27202 4.27496 7.56486 4.03464 7.90747 3.89273C8.25008 3.75081 8.62708 3.71368 8.99079 3.78603C9.35451 3.85838 9.6886 4.03695 9.95083 4.29918C10.213 4.5614 10.3916 4.89549 10.464 5.25921C10.5363 5.62292 10.4992 5.99992 10.3573 6.34253C10.2154 6.68514 9.97504 6.97798 9.66669 7.18401C9.35835 7.39003 8.99584 7.5 8.625 7.5"
      ></path>
      <path
        stroke="currentColor"
        d="M8.625 10.5C8.41789 10.5 8.25 10.3321 8.25 10.125C8.25 9.91789 8.41789 9.75 8.625 9.75"
      ></path>
      <path
        stroke="currentColor"
        d="M8.625 10.5C8.83211 10.5 9 10.3321 9 10.125C9 9.91789 8.83211 9.75 8.625 9.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 2.25V6.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 0.75C16.1478 0.75 16.5294 0.908035 16.8107 1.18934C17.092 1.47064 17.25 1.85218 17.25 2.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 0.75H15.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.75 2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.75 12.75V2.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 14.25C1.85218 14.25 1.47064 14.092 1.18934 13.8107C0.908035 13.5294 0.75 13.1478 0.75 12.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 14.25H2.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 18.75V14.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 16.5L5.25 18.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M23.25 18.75H20.25V23.25L15.75 18.75H11.25V9.75H23.25V18.75Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 12.75V15.75"
      ></path>
    </svg>
  );
};

export default ConversationQuestionWarningIcon;
